import React from "react"

import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

type GotoProps = {
  title: string
  linkName: string
  link: string
  target?: string
  rel?: string
}

export const Goto: React.FC<GotoProps> = ({ title, linkName, link, target, rel }) => {
  return (
    <Card className={styles.Wrapper}>
      <Heading className={styles.Title} like="h4">
        <Raw html={title} />
      </Heading>

      <Link className={styles.Link} href={link} rel={rel} target={target} view="arrow">
        <Raw html={linkName} />
      </Link>
    </Card>
  )
}
